import mapDataIE from '@highcharts/map-collection/custom/world-lowres.geo.json';
import { useMemo } from 'react';
import { COLORS } from '@consts/general';
import { useReportLoad } from '@hooks/useReportLoad';
import { BaseReport } from '../BaseReport';
import { count } from '@utils/summaries';
import { getCountriesInfo } from '@utils/data';
import { basicSort } from '@utils/sort';
import { styleDateRange } from '@utils/styles';
import { REPORT } from '@consts/reports';

interface GlobalPresenceProps {
    dateRange: { startDate: string; endDate: string };
}

export const GlobalPresence = ({ dateRange }: GlobalPresenceProps) => {
    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.MO_GLOBAL_PRESENCE,
        params: { ...dateRange },
    });

    const countryInfo = useMemo(() => getCountriesInfo(data), [data]);

    return (
        <BaseReport
            map
            title={'MO Global Presence'}
            description={'This map shows the countries which currently have active Mobile Outfitters locations around the world.'}
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Country Name'],
                data: data.map((item) => [item.country]),
                summaries: [count],
                sort: [basicSort],
            }}
            chartOptions={{
                chart: {
                    map: mapDataIE,
                    height: 500,
                    zoomType: 'xy',
                    animation: false,
                },
                title: 'Global Presence',
                credits: { enabled: false },
                mapNavigation: {
                    enabled: true,
                    mouseWheelSensitivity: 1.1,
                    enableButtons: true,
                    buttonOptions: {
                        padding: 2,
                        theme: {
                            fill: '#000',
                            stroke: 'transparent',
                        },
                    },
                    buttons: {
                        zoomIn: {
                            style: {
                                transform: 'translate(3px, 3px)',
                                color: '#FFF',
                            },
                        },
                        zoomOut: {
                            style: {
                                transform: 'translate(3px, 30px)',
                                color: '#FFF',
                            },
                        },
                    },
                },
                legend: {
                    enabled: false,
                },
                tooltip: {
                    headerFormat: '',
                    pointFormat: '<b>{point.name}</b>',
                },
                series: [
                    {
                        name: 'Global Presence',
                        data: [...countryInfo],
                        joinBy: ['iso-a3', 'code3'],
                        borderColor: COLORS.WHITE,
                        color: COLORS.BLUE,
                        nullColor: COLORS.NULL,
                        states: {
                            hover: {
                                color: COLORS.GREEN,
                            },
                        },
                    },
                ],
            }}
        />
    );
};
